export const TIME_SHIFTS = [
  {label: 'none', text: 'none', quantity: null, unit: null},
  {label: '1m', text: '1m', quantity: '1', unit: 'm'},
  {label: '1h', text: '1h', quantity: '1', unit: 'h'},
  {label: '12h', text: '12h', quantity: '12', unit: 'h'},
  {label: '1d', text: '1d', quantity: '1', unit: 'd'},
  {label: '7d', text: '7d', quantity: '7', unit: 'd'},
  {label: '30d', text: '30d', quantity: '30', unit: 'd'},
  {label: '365d', text: '365d', quantity: '365', unit: 'd'},
]
